import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './certificate-count.scss';

/**
 * Certificate Count and display component
 * Displays number of Gold, Silver and Bronze certificates earned by the student
 */
const CertificateCount = ({ icon, title, count }) => (
    <div className={css.component}>
        <div className={css.icon}><img src={icon} alt={title} /></div>
        <div className={css.title}>{title}</div>
        <div className={css.count}>{count}</div>
    </div>
);


CertificateCount.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    count: PropTypes.number
};

export default styleable(css)(CertificateCount);



// WEBPACK FOOTER //
// ./components/certificate-count/certificate-count.js